module.exports = __webpack_public_path__ + "static/media/info-circle-red.79f62fbc.svg";